type CookieOptions = {
    maxAge?: number
    domain?: string
    path?: string
    sameSite?: "Strict" | "Lax" | "None"
}

const setCookie = (name: string, value: string | number | boolean, options: CookieOptions = {}) => {
    if (typeof document === "undefined") return

    const { maxAge = 157680000, domain = process.env.COOKIE_DOMAIN, path = "/", sameSite = "Strict" } = options
    document.cookie = `${name}=${value}; max-age=${maxAge}; domain=${domain}; path=${path}; secure; SameSite=${sameSite}`
}

const getCookie = (name: string) => {
    if (typeof document === "undefined") return undefined

    return document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || undefined
}

const getCookies = (cookies: Record<string, string>) => {
    let cookieValues: Record<string, string | undefined> = {}
    Object.keys(cookies).forEach(key => (cookieValues[key] = getCookie(cookies[key])))
    return cookieValues
}

const deleteCookie = (name: string, options: Omit<CookieOptions, "maxAge"> = {}) => {
    if (typeof document === "undefined") return

    const { domain = process.env.COOKIE_DOMAIN, path = "/", sameSite = "Strict" } = options
    document.cookie = `${name}=; max-age=0; domain=${domain}; path=${path}; secure; SameSite=${sameSite}`
}

export { setCookie, getCookie, getCookies, deleteCookie }
